/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Trans } from "react-i18next";
import styles from "./Footer.module.scss";
import { FlexGrid } from "../_common";

export default class Footer extends React.Component {
  render() {
    return (
      <FlexGrid className={styles.footer} flexFlow="row" flex={0}>
        <FlexGrid flex={1} className={styles.leftPanel} flexFlow="row" />
        <FlexGrid className={styles.rightPanel} flex={0}>
          <div>
            <span>
              <Trans i18nKey={"Common.copyright"}>&copy; AccelByte 2019</Trans>
            </span>
          </div>
        </FlexGrid>
      </FlexGrid>
    );
  }
}
